export function usqrt32(n) {
	return Math.ceil(Math.sqrt(n)) | 0;
}
